import React, { useState, useEffect, useRef } from 'react';
import './AiSafety.css';
import { TbScanEye, TbFingerprintScan  } from "react-icons/tb";
import { RiSwordFill } from "react-icons/ri";
import { BsGlobe } from "react-icons/bs";
import { IoSearchCircleSharp } from "react-icons/io5";
import { GiStarsStack } from "react-icons/gi";
import { FaHandSpock , FaFlask, FaFilm, FaArrowAltCircleLeft   } from "react-icons/fa";
import { IoPeopleCircle } from "react-icons/io5";
import { PiShieldStarFill } from "react-icons/pi";
import { collection, query, where, orderBy, onSnapshot, addDoc, serverTimestamp, doc, getDocs, getDoc, setDoc, updateDoc, arrayUnion} from 'firebase/firestore';
import { db, auth } from '../../Firebase_Config/firebase';
import { NavLink } from "react-router-dom";




const toolsData = {
  AISafeFundamentals: {
    title: 'AI Safety Fundamentals – BlueDot Impact:',
    content: [
      `
      <p>The expertise you need to shape safe AI</p>
      <p>Learn alongside thousands of professionals through comprehensive courses designed with leading AI safety experts.</p>`
    ],
    link: 'https://bluedot.org/',
    buttonText:'Start Learning',
    accentClass: 'card-accent'
  },
  SafeAICourse: {
    title: 'AI Safety – Full Course by Safe.AI:',
    content: [
      `<p>A comprehensive 9-hour course exploring machine learning and ethics related to AI safety</p>
      <p>Dive into a comprehensive 9-hour course on AI Safety, exploring crucial aspects of machine learning and ethics.Learn how to shape the development of strong AI systems in a safer direction, covering topics such as robustness, monitoring, alignment, and systemic safety. Explore deep learning fundamentals, risk decomposition, accident models, black swans, adversarial robustness, anomaly detection, and interpretable uncertainty. Delve into transparency, trojans, detecting emergent behavior, honest models, and machine ethics. Examine ML applications in improved decision-making and cyberdefense, as well as cooperative AI concepts. Analyze potential existential hazards, the relationship between AI and evolution, and the balance between safety and capabilities. Gain valuable insights to help reduce existential risks from advanced AI systems and contribute to the field of AI safety research.</p>
      `      
    ],
    buttonText:'Start Learning',
    link: 'https://www.classcentral.com/course/freecodecamp-ai-safety-full-course-from-safe-ai-on-machine-learning-ethics-204915',
    accentClass: 'card-accent alt'
  },
  
  Video: {
    title: 'Practical Data Ethics – fast.ai:',
    content: [
        `<p>Focuses on real-world topics like disinformation and bias, providing practical tools for data ethics</p>`
    ],
    buttonText:'Start Learning',
    link: 'https://ethics.fast.ai/',
    accentClass: 'card-accent alt'
  },
};


const AISafety = () => {
    const getUserId = () => {
    const user = auth.currentUser;
    return user.uid;
  };
    const CommentsSection = () => {
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [userName, setUserName] = useState("");
  
    useEffect(() => {
  
      const fetchSectorNameAndScores = async () => {
              try {
                  const userId = getUserId();
                  console.log('User ID:', userId); // Add this line for debugging     
                  const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
                  const userDocSnapshot = await getDocs(userDocQuery);     
                  if (!userDocSnapshot.empty) {                      
                      const userDocData = userDocSnapshot.docs[0].data();                  
                      const UserName =userDocData.UserName ||0;
                      setUserName(UserName)                        
                  } else {
                      console.log('User document not found for user ID:', userId);
                  }                  
                    } catch (error) {
                        console.error('Error fetching document:', error);
                    }
          };      
          fetchSectorNameAndScores();

          const commentsDocRef = doc(db, "comments_Ethics101", "mainThread");

          const unsubscribe = onSnapshot(commentsDocRef, (docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              setComments(data.messages || []);
            } else {
              // If the document doesn't exist yet, create it
              setDoc(commentsDocRef, { messages: [] });
            }
          });
  
      return () => unsubscribe();
    }, []);
  
    const handlePostComment = async () => {
      const trimmed = comment.trim();
      if (!trimmed) return;
  
      const user = auth.currentUser;
      if (!user) return;
  
      const newComment = {
        text: trimmed,
        author: userName,
        uid: user.uid,
        timestamp: new Date().toISOString(),
      };
  
      const commentsDocRef = doc(db, "comments", "mainThread");
  
      try {
        await updateDoc(commentsDocRef, {
          messages: arrayUnion(newComment),
        });
        setComment("");
      } catch (error) {
        console.error("Error posting comment:", error);
      }
    };
  
    return (
      <div style={{  margin: "auto" }}>
        <h2>Comments</h2>
        <div>
          <input
                  className="form_input"
                  type="text"
                  id="comment"
                  name="comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add a comment..."
                />
          <button className='full-width-button' onClick={handlePostComment} >
            Comment
          </button>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          {comments
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .map((c, index) => (
              <div
                key={index}
                style={{ borderBottom: "1px solid #ccc", padding: "1rem 0" }}
              >
                <strong>{c.author}</strong>
                <p>{c.text}</p>
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  {new Date(c.timestamp).toLocaleString()}
                </div>
              </div>
            ))}
        </div>
        {/*<textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Leave a comment..."
          style={{ width: "100%", padding: "0.5rem" }}
        />*/}
       
      </div>
    );
  };

    const [selectedTool, setSelectedTool] = useState('AISafeFundamentals');
    const renderCard = () => {
      const tool = toolsData[selectedTool];

      if (selectedTool === 'Video') {
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">Data Ethics 101 Navigating AI's Morals</h2>
              <div className='trainPP'>
                <video autoPlay controls>
                <source src="/Videos/DataEthics101.webm" type="video/mp4"/>
              </video>
              </div>
              
              <CommentsSection/>
            </div>
          </div>
        </div>
      );
    }
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">{tool.title}</h2>
              {tool.content.map((paragraph, idx) => (
                <div dangerouslySetInnerHTML={{ __html: tool.content }} ></div>
              ))}
              <a href={tool.link} target="_blank" rel="noopener noreferrer" className="full-width-button">
                {tool.buttonText}
              </a>
            </div>
          </div>
        </div>
      );
    };



  return (
    <div className='backgroundHelp'>
      <div className="InternetHyContent">
        <div className='bannerBG'>
          <img src="../banner.png" alt="banner2" className='banner-image' />
        </div>
        <h1 className="helptitle bigger">AI Saftey</h1>
        <div className='BasicGrid'>
          <div className='BasicGrid2'>
            <NavLink to="/Support" >
              <button className="navButtons">
                <div>
                  <FaArrowAltCircleLeft className="helpicons" />
                </div>
                <span>Back</span>
              </button>
            </NavLink>
            <button className="navButtons" onClick={() => setSelectedTool('AISafeFundamentals')}>
              <div>
                <GiStarsStack className="helpicons" />
              </div>
              <span>AI Safety Fundamentals</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('SafeAICourse')}>
              <div>
                <PiShieldStarFill className="helpicons" />
              </div>
              <span>SafeAI Course</span>
            </button>
           
          </div>      
        </div>
        <br/>
        <div className="help-hrLine" />
        <br/>
        {renderCard()}   
      </div>
    </div>
  );
};

export default AISafety;
